import easyMDE from "easymde";

export default function () {
    return {
        section: "",
        showEnglish: false,

        init() {
            this.configureMarkdownEditor();
        },

        tabClass(section) {
            return {
                'border-green-400': section == this.section,
                'border-transparent': section != this.section,
            }
        },

        configureMarkdownEditor() {
            const editorFields = document.querySelectorAll(".js-text-editor");

            [].forEach.call(editorFields, el => {
                let mdeConfig = {
                    element: el,
                    spellChecker: false,
                    nativeSpellcheck: true,
                    status: false,
                    toolbar: [
                        'bold', 'italic', 'heading', '|',
                        'quote', 'unordered-list', 'ordered-list', '|',
                        'link', '|',
                        {
                            name: "help",
                            action: function customFunction(editor) {
                                const win = window.open('/help/markdown', '_blank');
                                win.focus();
                            },
                            className: "fa fa-question-circle",
                            title: "Help",
                        }
                    ]
                };

                if (el.dataset.editorHeight === 'small') {
                    mdeConfig.minHeight = '100px';
                }

                if (el.dataset.editorStyle === 'minimal') {
                    mdeConfig.toolbar = ["bold", "italic"];
                }

                var editor = new easyMDE(mdeConfig);

                if (el.dir && el.dir == 'rtl') {
                    editor.codemirror.setOption('direction', 'rtl');
                }
            });
        }

    }
}